import {
  Box,
  BoxProps,
  forwardRef,
  Icon,
  ResponsiveValue,
} from '@chakra-ui/react'
import React from 'react'
import modalCloseIcon from '~/assets/svgs/icon-close-x.svg?react'
import {
  MangoCloseButtonVariant,
  useMangoCloseButtonStyles,
} from '~/components/shared/componentStyles/MangoCloseButton.style'
import { Size } from '~/types/ThemeTypes'

type MangoCloseButtonProps = BoxProps & {
  onClick?: () => void
  variant?: MangoCloseButtonVariant
  size?: ResponsiveValue<Size.sm | Size.md | Size.lg>
}

export const MangoCloseButton = forwardRef<MangoCloseButtonProps, 'div'>(
  (props: MangoCloseButtonProps, ref) => {
    const {
      onClick,
      variant = MangoCloseButtonVariant.Primary,
      ...rest
    } = props
    const styles = useMangoCloseButtonStyles({ variant, size: props.size })
    return (
      <Box
        ref={ref}
        {...rest}
        {...props}
        sx={styles.closeButton}
        onClick={onClick}
      >
        <Icon sx={styles.closeButtonIcon} as={modalCloseIcon} />
      </Box>
    )
  },
)
